import { StoreState } from 'state/types';
import { TimesheetsWeekSummaryReducerState } from './types';

const getState = (state: StoreState): TimesheetsWeekSummaryReducerState =>
  state.timesheetsWeekSummary;

const getTimesheetsWeekSummary = (state: StoreState) => getState(state).timesheetsWeekSummary;
export const getTimesheetsWeekSummaryTotal = (state: StoreState) => getTimesheetsWeekSummary(state).total;
